import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  CollegeTier,
  UserCollege,
  UserCollegeStatus,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { tierLabel } from './components/TierChip';

type MyCollegesAgentContext = Readonly<{
  view: 'table' | 'cards';
  statusFilter: UserCollegeStatus | null;
  fieldFilter: readonly string[];
  levelFilter: CollegeTier | null;
  colleges: readonly UserCollege[];
}>;

export const useAgentContext = ({
  view,
  statusFilter,
  fieldFilter,
  levelFilter,
  colleges,
}: MyCollegesAgentContext) => {
  useRegisterAgentContext({
    kind: 'list',
    description: `The colleges on the student's My College List, shown as a ${view === 'table' ? 'table' : 'set of cards'} grouped by Safety / Target / Reach${statusFilter ? `, filtered to status "${statusFilter}"` : ''}${levelFilter ? `, filtered to ${tierLabel(levelFilter)} colleges` : ''}${fieldFilter.length ? `, filtered to colleges with a bachelor's in any of: ${fieldFilter.join(', ')} (the field of study filter starts on the fields the student picked on the College Shortlist)` : ''}. A search at the top adds more schools to the list. Tier is Backrs' rating for this student; "Not rated" means it could not be rated. A null admissions fact is one Backrs does not have. net_cost is per year: from the student's saved award letter when net_cost_source is "award_letter", a College Scorecard estimate for families at their income when it is "scorecard", or the college's average for all aided students when it is "average" (the student has no family income on their profile, or the college has no price for it).`,
    data: colleges.map((college) => ({
      name: college.name,
      tier: tierLabel(college.tier),
      status: college.status,
      application_plan: college.application_plan,
      my_deadline: college.my_deadline,
      rolling_admission: college.rolling_admission,
      early_action: college.early_action,
      early_action_restrictive: college.early_action_restrictive,
      early_action_deadline: college.early_action_deadline,
      test_optional: college.test_optional,
      essay_requirement: college.essay_requirement,
      recommendation_requirement: college.recommendation_requirement,
      interview_requirement: college.interview_requirement,
      net_cost: college.net_cost,
      net_cost_source: college.net_cost_source,
      has_award_letter: college.has_award_letter,
    })),
  });
};
